import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-floating" }
const _hoisted_2 = ["disabled", "aria-label"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
      disabled: _ctx.isDisabled,
      "aria-label": _ctx.ariaLabel
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.value,
          value: item.value
        }, _toDisplayString(item.text), 9, _hoisted_3))
      }), 128))
    ], 8, _hoisted_2), [
      [_vModelSelect, _ctx.selectedValue]
    ]),
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
  ]))
}